export default __webpack_public_path__ + "static/media/filters.0dcaa801.svg";